module.exports = __webpack_public_path__ + "static/02-bd56c40a7329a5ada14a2efc863e7170.jpg";